// src/components/Portfolio/DeficienciesObjects/GreenTeaExtract.js

const MushroomD2 = {
  productCode: "SBPNVZ-D2",
  productName: "Mushroom D2",
  ingredients: "Mushrooms",
  overview:"D2 is a mushroom extract standardized for Ergocalciferol a natural whole-food source of Vitamin D with controlled sunlight exposure. Researchers from Boston University School of Medicine have found that vitamin D2 is equally as effective as vitamin D3 in maintaining 25-hydroxyvitamin D status",
  assay:"Natural Ergocalciferol  2 %",
  coNutrients:"Ergothioneine, Fucogalactans, Fucomannogalactans, and pyrogallols are a few metabolites identified to have been retained in the extracts. However, the extract is standardized for this purpose. ",
  studies:"Comprehensive Stability studies, ongoing studies to understand the medicinal benefits that has not been reported.",
  benefits:"Ergocalciferol as a supplement helps Vitamin D function, skin care, strengthen bones, regulate immune response, as a powerful anti-oxidant and as an anti-carcinogen. Help improve parathyroid function, low phosphate levels",
  functionalUse: {
    main: "💊︎ Capsule, 🍚︎ Foods, 🥛︎ Beverages, 🚰︎ ORS, ⊘ Tablets (sensitive), 🍞︎ Baking,  🧂︎ Seasonings, 🍨︎ ice creams",
    note: "(Note:- heat and light sensitive, prone to oxidative stress)"
  },
  bannerImage: [
    "images/Portfolio/OrgavitazForDeficiencies/MushroomD2/M1.png",
    "images/Portfolio/OrgavitazForDeficiencies/MushroomD2/M2.png",
    "images/Portfolio/OrgavitazForDeficiencies/MushroomD2/M3.png",
    "images/Portfolio/OrgavitazForDeficiencies/MushroomD2/M4.png",
    "images/Portfolio/OrgavitazForDeficiencies/MushroomD2/M5.png",



  ],
  certificates: [
   "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L1.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L2.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L3.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L4.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L6.png",
  ]
};

export default MushroomD2;
